<template>
	<div class="adv-titled-list">
		<div v-if="title" :class="['title', { 'ctc-title': isCTC }]">
			<adv-list-item :item-data="titleData" @select="onTitleSelect"/>
			<span v-if="collapsable" class="collapse-icon" role="button" :aria-label="collapseAriaLabel" @click="toggleCollapse" @keydown.enter="toggleCollapse" tabindex="0">{{ collapseIcon }}</span></div>
		<div :class="collapsed? 'collapsed':null">
			<adv-list :items="filteredItems" @select="$emit('select', $event)"/>
			<div v-if="hasMore" class="has-more highlight" @click="showAll = true">See more {{ title }}</div>
			<slot/>
		</div>
	</div>
</template>

<script>
import AdvList from "@/components/lists/AdvList";
import AdvListItem from "@/components/lists/AdvListItem";
import { mapGetters } from "vuex";

export default {
	name: "AdvTitledList",
	components: {AdvListItem, AdvList},
	props: {
		title: {
			type: [String, Object]
		},
		items: {
			type: Array,
			default: () => []
		},
		maxVisible: {
			type: Number,
			default: null
		},
		collapsable: {
			type: Boolean,
			default: false
		},
		isCollapsed: {
			type: Boolean,
			default: false
		},
		enableToggleAll: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showAll: false,
			collapsed: false
		}
	},
	created() {
		if (this.collapsable) {
			if (this.someSelected && !this.allSelected) {
				this.collapsed = false;
			} else {
				this.collapsed = this.isCollapsed
			}
		}
	},
	computed: {
	 ...mapGetters(['isCTC', 'content']),
		filteredItems() {
			if (!this.maxVisible) return this.items;
			const e = this.showAll ? this.items.length : this.maxVisible;
			return this.items.slice(0, e);
		},
		hasMore() {
			return this.items.length > this.filteredItems.length;
		},
		collapseIcon() {
			return this.collapsed ? '+' : '-';
		},
		collapseAriaLabel() {
			const caption = this.titleData?.label || '';
			const phrase = this.collapsed ? this.content.expandOptionsAbout : this.content.collapseOptionsAbout;
			return `${phrase} ${caption}`;
		},
		someSelected() {
			if (!Array.isArray(this.items)) return false;
			return this.items.some((item) => {
				return item.checkbox.selected;
			})
		},

		allSelected() {
			if (!Array.isArray(this.items) || !this.items.length) return false;
			const ts = this.items.reduce((pv, item) => {
				let val = item.checkbox.selected ? 1 : 0;
				if (typeof pv === 'object') {
					val += pv.checkbox.selected ? 1 : 0;
				} else {
					val += pv;
				}
				return val;
			});

			return ts === this.items.length;
		},

		titleData() {
  if (!Array.isArray(this.items)) return null;

  const d = typeof this.title === 'object'
    ? { ...this.title }
    : { label: this.title };

  if (this.enableToggleAll && !d.checkbox) {
					d.checkbox = {
						selected: this.allSelected
					}
				}
  return d;
},

		titleSelected() {
			if (!Array.isArray(this.items)) return false;
			return this.titleData?.checkbox?.selected;
		}
	},
	methods: {
		toggleCollapse() {
			this.collapsed = !this.collapsed;
			this.$emit('toggleCollapse', this.titleData);
		},
		onTitleSelect(d) {
			if (!Array.isArray(this.items)) return false;
			console.log('on Filter Title select:', d)
			if (this.enableToggleAll) {
				const selected = d.checkbox?.selected;
				const applySelected = (item) => {
					if (item && item.checkbox) {
						item.checkbox.selected = selected;
					}
					if (Array.isArray(item?.subItems)) {
						item.subItems.forEach(applySelected);
					}
				};
				this.items.forEach(applySelected);
			}
			this.$emit('select', d);
		}
	},
	watch: {
		allSelected(v) {
			if (this.enableToggleAll && this.titleData?.checkbox) this.titleData.checkbox.selected = v;
		},
		titleSelected(v) {
			//console.log('titleSelec Toggled:', v)
			if (this.enableToggleAll) {
				if ((v && !this.allSelected) || (!v && this.allSelected)) {
					this.onTitleSelect(this.titleData);
				}
			}

		}
	}
}
</script>

<style lang="scss" scoped>
.adv-titled-list {
	padding-left: 0px;
  .title {
	padding: 0.65em 0;
	display: flex;
	justify-content: space-between;
	border-bottom: solid 1px #afafaf;
	margin-bottom: 0.8em;
	text-transform: none;	
	font-size: 11px;
 	align-items: center;  
	.collapse-icon {
	min-width: 38px;            
	text-align: center;
	font-size: 12px;
	cursor: pointer;
	} 
	.adv-list-item {
	  margin-right: 1em;
	 
	  color: black;   
	 
	}
  }
.ctc-title {
	.adv-list-item {
		margin-right: 1em;
		color: black;   
		padding-left: 16px;
	}
	}
  .has-more {
	font-size: smaller;
	margin-top: 1em;
	cursor: pointer;
	
  }

  .collapsed {
	display: none;
  }

  &.sub-menu {
	display: flex;
	flex-direction: column;
	 row-gap: 8px;

	.title {
	  padding: 2px;
	  border-bottom: none;
	  margin-bottom: 0px;
	  
	 
	}
  }
}
</style>
